import { client_query_engine } from '../http_client';
import { DisseminationStatusResponse } from './types';

export const root = '/v1/forecast';

export class DisseminationService {
  public static async getStatus(
    models: string[],
    since?: Date,
    before?: Date,
    limit: number = 200,
  ): Promise<DisseminationStatusResponse> {
    const params = new URLSearchParams();

    // Add models as array parameter
    models.forEach((model) => {
      params.append('models', model);
    });

    // Default to 7 days ago if no since date provided
    const sinceDate = since || new Date(Date.now() - 7 * 24 * 60 * 60 * 1000);
    params.set('since', sinceDate.toISOString());

    if (before) {
      params.set('before', before.toISOString());
    }

    params.set('limit', limit.toString());

    const url = `${root}/dissemination-status?${params}`;
    const response = await client_query_engine.get<DisseminationStatusResponse>(url);
    return response.data;
  }
}
